"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

var base = /*#__PURE__*/(0, _react.css)("max-width:", (0, _util.rem)(280), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));

var text = function text(theme) {
  return /*#__PURE__*/(0, _react.css)("padding:", theme.spacing[4], " ", theme.spacing[7], ";background-color:", theme.color.facebookMessenger.commentBackground, ";border-radius:", (0, _util.rem)(18), ";display:inline-flex;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:text;"));
};

var avatarContainer = function avatarContainer(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[14], ";height:", theme.spacing[14], ";flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:avatarContainer;"));
};

var styles = {
  text: text,
  base: base,
  avatarContainer: avatarContainer
};
exports.styles = styles;
//# sourceMappingURL=Message.styles.js.map